/**
 * Apoio do captcha (Cloudflare Turnstile) das telas de entrada — ver `components/Captcha`.
 * Separado do componente porque o fast refresh só funciona em arquivo que exporta só componente.
 */

/* Captcha DESLIGADO até configurar o Turnstile (04/11/2026). Sem site key, o widget não aparece
   nas três telas e elas não esperam token. Para ligar: descomentar a linha de baixo, apagar a do
   `undefined` e descomentar as checagens no AuthController (Login, Register, SolicitarRedefinicao). */
// export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;
export const TURNSTILE_SITE_KEY: string | undefined = undefined;

/** Sem site key o widget não aparece e a tela não espera token. */
export const captchaAtivo = Boolean(TURNSTILE_SITE_KEY);

/** Header que a API confere (X-Captcha-Token). Vazio quando não há token. */
export const cabecalhoCaptcha = (token: string | null): Record<string, string> =>
    token ? { 'X-Captcha-Token': token } : {};
